export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || "test";
